<template v-slot="{ greeting }">
  <div
    :style="{ backgroundColor: themedBackground?.mainContent }"
    class="mainBg border rounded-md overflow-hidden shadow-lg shadow-darkGray-1/40 border-gray-100 grid w-full"
    v-if="isLoaded"
  >
    <div
      class="flex w-full flex-col gap-4 md:gap-8 place-self-center items-center"
    >
      <div class="relative w-full h-[140px] overflow-hidden">
        <img
          v-if="props.banner && props.banner !== ''"
          :src="props.banner"
          class="w-full h-full object-cover min-h-[200px] max-h-[400px]"
        />
        <div
          v-else
          class="grid place-content-center bg-blue-4 p-2 w-full h-full"
        >
          <i class="fas fa-image text-4xl text-gray-300"></i>
        </div>
      </div>
      <div class="w-11/12 max-w-screen-xl">
        <h2
          :style="{ color: themedText?.workAtText }"
          :class="`text-sm font-semibold leading-8 tracking-tight workAtText`"
        >
          Jobba hos {{ $store.getters.container?.name }}
        </h2>
      </div>
    </div>
    <div class="flex flex-col gap-4 sm:gap-8 m-auto w-11/12 max-w-screen-xl">
      <div
        v-if="isLoaded"
        class="flex justify-between gap-4 items-end sm:items-baseline"
      >
        <p
          :style="{ color: themedText?.otherText }"
          class="mt-2 text-base font-bold tracking-tight ${the} text-gray-900"
        >
          Just nu har vi 2 lediga tjänster
        </p>
      </div>

      <ul role="list" class="divide-y divide-gray-200" v-if="isLoaded">
        <li class="py-2 sm:px-0">
          <div class="px-0 py-2 flex justify-between">
            <div
              class="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap w-full py-2"
            >
              <div class="ml-4 flex flex-wrap">
                <div>
                  <h3
                    :style="{ color: themedText?.otherText }"
                    :class="`text-sm font-medium leading-6 ${themedText?.otherText} text-gray-900 cursor-pointer`"
                  >
                    Namn på annons
                  </h3>
                </div>
              </div>
              <div class="flex flex-wrap gap-x-4 items-center">
                <div class="text-sm text-gray-500">
                  <i
                    :style="{ color: themedIcon?.positionIcon1 }"
                    class="fa-solid fa-building place-self-center text-blue-2"
                  ></i>
                </div>
                <div class="text-sm text-gray-500 flex gap-2 items-center">
                  <i
                    :style="{ color: themedIcon?.positionIcon2 }"
                    class="fa-solid fa-location-dot place-self-center text-pink-1"
                  ></i>
                  <p
                    :style="{ color: themedText?.detailText }"
                    class="text-darkGray-3"
                  >
                    Stockholm
                  </p>
                </div>
                <div class="text-sm text-gray-500 flex gap-2 items-center">
                  <i
                    :style="{ color: themedIcon?.positionIcons }"
                    class="fa-regular fa-calendar-check place-self-center text-azure-1"
                  ></i>
                </div>
              </div>
              <div class="ml-4 flex-shrink-0">
                <span
                  :style="{
                    color: themedButton?.textColor,
                    backgroundColor: themedButton?.backgroundColor,
                    borderRadius: themedButton?.borderRadius,
                  }"
                  type="button"
                  :class="`${
                    themedButton?.borderRadius || 'rounded-md'
                  } coloredButton bg-blue-1 relative inline-flex items-center border border-transparent px-4 py-2 text-xs font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`"
                >
                  Läs mer och ansök
                </span>
              </div>
            </div>
          </div>
        </li>
        <li class="py-2 sm:px-0">
          <div class="px-0 py-2 flex justify-between">
            <div
              class="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap w-full py-2"
            >
              <div class="ml-4 flex flex-wrap">
                <div>
                  <h3
                    :style="{ color: themedText?.otherText }"
                    :class="`text-sm font-medium leading-6 text-gray-900 cursor-pointer`"
                  >
                    Namn på annons
                  </h3>
                </div>
              </div>
              <div class="flex flex-wrap gap-x-4 items-center">
                <div class="text-sm text-gray-500">
                  <i
                    :style="{ color: themedIcon?.positionIcon1 }"
                    class="fa-solid fa-building place-self-center text-blue-2"
                  ></i>
                </div>
                <div class="text-sm text-gray-500 flex gap-2 items-center">
                  <i
                    :style="{ color: themedIcon?.positionIcon2 }"
                    class="fa-solid fa-location-dot place-self-center text-pink-1"
                  ></i>
                  <p
                    :style="{ color: themedText?.detailText }"
                    class="text-darkGray-3"
                  >
                    Stockholm
                  </p>
                </div>
                <div class="text-sm text-gray-500 flex gap-2 items-center">
                  <i
                    :style="{ color: themedIcon?.positionIcons }"
                    class="fa-regular fa-calendar-check place-self-center text-azure-1"
                  ></i>
                </div>
              </div>
              <div class="ml-4 flex-shrink-0">
                <span
                  :style="{
                    color: themedButton?.textColor,
                    backgroundColor: themedButton?.backgroundColor,
                    borderRadius: themedButton?.borderRadius,
                  }"
                  type="button"
                  :class="`${
                    themedButton?.borderRadius || 'rounded-md'
                  } bg-blue-1 relative inline-flex items-center border border-transparent px-4 py-2 text-xs font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`"
                >
                  Läs mer och ansök
                </span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <footer
      :style="{ backgroundColor: themedBackground?.footer }"
      class="footerBg bg-darkGray-1 mt-2"
    >
      <div class="w-11/12 max-w-screen-xl py-4 mx-auto" id="footerBg">
        <div class="flex items-start flex-row justify-between gap-8">
          <div class="flex flex-row items-start gap-4">
            <div
              class="flex place-content-center bg-white overflow-hidden px-1 rounded-md w-[80px]"
            >
              <Logotype :logo="containerByDNS?.CompanyLogo?.data" />
            </div>
            <div class="text-xs flex flex-col gap-2 text-white">
              <p
                :style="{ color: themedText?.footerText }"
                class="font-medium text-center md:text-left"
              >
                {{ $store.getters.container.name }}
              </p>
            </div>
          </div>
          <div
            :class="['flex flex-row gap-x-2 gap-y-4 justify-between text-xs']"
          >
            <div class="text-left">
              <p
                :style="{ color: themedText?.contactText }"
                class="contactText text-sm font-medium text-blue-3.5"
              >
                Kontakta oss
              </p>

              <nav class="mt-2">
                <ul class="space-y-2 text-left mx-auto">
                  <li
                    v-if="containerByDNS?.PhoneNumber?.data"
                    class="items-center text-gray-2 flex mx-auto"
                  >
                    <span
                      class="sm:place-self-start transition hover:text-gray-2/75"
                      ><i class="fas fa-phone w-[32px]"></i
                      >{{ containerByDNS?.PhoneNumber?.data }}</span
                    >
                  </li>
                  <li
                    v-if="containerByDNS?.Email?.data"
                    class="items-center text-gray-2 flex mx-auto"
                  >
                    <span
                      class="sm:place-self-start transition hover:text-gray-2/75"
                      ><i class="fas fa-envelope w-[32px]"></i
                      >{{ containerByDNS?.Email?.data }}</span
                    >
                  </li>
                  <li class="items-center text-gray-2 flex mx-auto">
                    <span
                      class="sm:place-self-start transition hover:text-gray-2/75"
                      ><div class="flex flex-col text-left">
                        <span>
                          <span
                            class="inline-block"
                            :style="{ color: themedText?.footerText }"
                            ><i
                              class="block fas fa-map-marker-alt w-[32px] justify-center"
                            ></i
                          ></span>
                          <span :style="{ color: themedText?.footerText }"
                            >Gatuadress</span
                          >
                        </span>
                        <span
                          class="ml-8"
                          :style="{ color: themedText?.footerText }"
                        >
                          123 45 Stad
                        </span>
                      </div>
                    </span>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <div class="pt-4 mt-4 border-t border-gray-2 text-xs">
          <div
            class="text-center sm:flex sm:justify-between md:text-left grid grid-cols-1 xl:grid-cols-3 items-center gap-4"
          >
            <ul
              class="flex justify-center gap-2 md:gap-3 sm:justify-start items-center"
            >
              <li>
                <div class="text-white transition hover:text-blue-4/75">
                  <span class="sr-only">Facebook</span>
                  <i
                    :style="{ color: themedIcon?.footerIcon }"
                    class="fab fa-facebook-f footerBgicon"
                  ></i>
                </div>
              </li>

              <li>
                <div class="text-white transition hover:text-blue-4/75">
                  <span class="sr-only">Instagram</span>
                  <i
                    :style="{ color: themedIcon?.footerIcon }"
                    class="fab fa-instagram footerBgicon"
                  ></i>
                </div>
              </li>

              <li>
                <div class="text-white transition hover:text-blue-4/75">
                  <span class="sr-only">X</span>
                  <i
                    :style="{ color: themedIcon?.footerIcon }"
                    class="fab fa-x-twitter footerBgicon"
                  ></i>
                </div>
              </li>
              <li>
                <div class="text-white transition hover:text-blue-4/75">
                  <span class="sr-only">LinkedIn</span>
                  <i
                    :style="{ color: themedIcon?.footerIcon }"
                    class="fab fa-linkedin-in footerBgicon"
                  ></i>
                </div>
              </li>

              <li>
                <div class="text-white transition hover:text-blue-4/75">
                  <span class="sr-only">GitHub</span>
                  <i
                    :style="{ color: themedIcon?.footerIcon }"
                    class="fab fa-github footerBgicon"
                  ></i>
                </div>
              </li>
              <li>
                <div class="text-white transition hover:text-blue-4/75">
                  <span class="sr-only">YouTube</span>
                  <i
                    :style="{ color: themedIcon?.footerIcon }"
                    class="fab fa-youtube footerBgicon"
                  ></i>
                </div>
              </li>
            </ul>

            <p
              :style="{ color: themedText?.footerText }"
              class="text-xs text-gray-3 sm:order-first sm:mt-0"
            >
              I samarbete med
              <span
                :style="{ color: themedText?.footerText }"
                class="text-white transition hover:text-white/75"
                >ansökningsportal.se</span
              >
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, watch, computed } from "vue";
import { Profile } from "@/models/Profile";
import { useStore } from "vuex";
import Logotype from "@/features/shared/components/ui/Logotype.vue";
import { MainContainer } from "@/models/MainContainer";
// import { CustomTheme } from "@/models/dtos";

const props = defineProps({
  banner: {
    type: String,
    default: "",
    required: true,
  },
});

const store = useStore();
const isLoaded = ref(false);
const containerByDNS = ref<Profile>(null);

// const theme = ref(new CustomTheme())

// // Använd watch för att observera ändringar i temat
// watch(() => store.getters.getContainerTheme, (newTheme) => {
//   theme.value = newTheme;

//   // Kolla om temat är laddat
//   if (theme.value) {
//     // Nu kan du använda det nya temat här och uppdatera din komponent enligt behov
//     console.log("Ny bakgrundsfärg:", theme.value.backgroundColor.mainContent);
//     console.log("Ny textfärg:", theme.value.textColor.otherText);
//     console.log("Ny borderRadius:", theme.value.button.borderRadius);
//     // Uppdatera din komponent med de nya tematiska värdena
//   }
// });

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

const themedText = computed(() => store.getters.getContainerThemedText);
const themedButton = computed(() => store.getters.getContainerThemedButton);
const themedBackground = computed(
  () => store.getters.getContainerThemedBackground
);
const themedIcon = computed(() => store.getters.getContainerThemedIcon);
</script>
